
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/profile-2user"}},[_c('path',{attrs:{"d":"M7.252 8.605a1.439 1.439 0 00-.261 0 3.519 3.519 0 11.261 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M12.988 3.167a2.769 2.769 0 012.774 2.771 2.775 2.775 0 01-2.668 2.771.894.894 0 00-.206 0","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M3.293 11.527c-1.916 1.282-1.916 3.372 0 4.647a7.731 7.731 0 007.925 0c1.916-1.282 1.916-3.372 0-4.647a7.768 7.768 0 00-7.925 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M14.519 15.833a3.829 3.829 0 001.552-.689 2.005 2.005 0 000-3.38 3.937 3.937 0 00-1.528-.681","opacity":".4"}})])])
          )
        }
      }
    